import {ComplianceManagerApi} from "../../../compliance-manager";
import {Col, Descriptions, Row, Typography} from "antd";
import ComplianceStatusButton from "components/compliance/compliance-status-button";
import {momentOrNull} from "common/util";
import useBreakpoints from "hooks/useBreakpoints";
import {ProviderType} from "__generated__/graphql/types";
import {usePaxNodeQuery} from "../../../../graphql";
import React from "react";
import {NextExpirationDate} from "../../../../NextExpirationDate";

/**
 * Tab for displaying ICAN result details.
 */
export default function IcanTab(props: { api: ComplianceManagerApi }){

    const { api } = props;

    const bp = useBreakpoints();

    const paxID = api.paxContext?.paxNode?._id;

    const { paxNode } = usePaxNodeQuery(paxID);

    const isSmallScreen = bp.max("medium");

    const complianceResult = api.complianceResult;
    const normalizedIcanResult = complianceResult?.icanProviderResult;
    const icanResult = normalizedIcanResult?._icanResult;
    const hasError = !!normalizedIcanResult?.error;

    return <div style={{ marginTop: 12 }}>
        <Row style={{marginTop: "1.5rem", marginBottom: "1rem"}} type="flex" gutter={12}>
            {paxNode ? (
                <Col>
                    <h4>VERIFLYT Details for <span style={{textTransform: 'capitalize'}}>{paxNode?.lastName}</span>, <span style={{textTransform: 'capitalize'}} >{paxNode?.firstName}</span></h4>
                </Col>
            ) : null}
        </Row>
        <Descriptions
            className="mc-compliance-manager-details"
            bordered
            column={1}
            size="small"
            layout={isSmallScreen ? 'vertical' : 'horizontal'}
        >
            <Descriptions.Item label="Status">
                <ComplianceStatusButton
                    pax={api.paxContext}
                    disabled
                    showSourcesTooltip={false}
                    selectedProvider={ProviderType.ICAN}
                />
            </Descriptions.Item>
            <Descriptions.Item label="ICAN Result">
                {icanResult?.icanResult}
            </Descriptions.Item>
            <Descriptions.Item label="ICAN ID">
                {icanResult?.icanId}
            </Descriptions.Item>
            {normalizedIcanResult?.reason ? (
                <Descriptions.Item label="Reason">
                    {normalizedIcanResult?.reason}
                </Descriptions.Item>
            ) : null}
            <Descriptions.Item label="Last Check Time">
                {momentOrNull(normalizedIcanResult?.startTs)?.format('YYYY-MM-DD HH:MM')}
            </Descriptions.Item>
            {!!normalizedIcanResult?.nextExpirationDate && (
                <Descriptions.Item label="Next Expiration">
                    <NextExpirationDate date={normalizedIcanResult.nextExpirationDate} />
                    {' '}
                    {normalizedIcanResult?.nextExpirationQualificationName ? `(${normalizedIcanResult?.nextExpirationQualificationName})` : ''}
                </Descriptions.Item>
            )}
            {hasError ? (
                <Descriptions.Item label="Error Message" className="mc-compliance-manager-error">
                    <Typography.Text type="danger">{normalizedIcanResult?.error}</Typography.Text>
                </Descriptions.Item>
            ) : null}
            <Descriptions.Item label="Duration">
                {normalizedIcanResult?.latencyMs} ms
            </Descriptions.Item>
        </Descriptions>
    </div>
}